import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { CloudOff } from "lucide-react";

/**
 * Calm offline notice. The PWA shell loads from cache when offline; this
 * tells the user why nothing new is arriving instead of surfacing broken
 * fetches.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  return (
    <AnimatePresence>
      {offline && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          className="sticky top-0 z-[90] flex items-center justify-center gap-2 px-4 py-2 bg-muted/90 backdrop-blur-sm border-b border-border/40 text-muted-foreground"
          style={{ paddingTop: "max(0.5rem, var(--safe-top))", fontSize: "0.8rem" }}
        >
          <CloudOff size={14} className="shrink-0" />
          <span style={{ fontFamily: "'Fraunces', Georgia, serif", fontStyle: "italic" }}>
            You're offline — your burrow will sync when you're back.
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
